import CourseCodes from '@/models/CourseCodes.js';
import CourseTemplate from '@/models/CourseTemplate.js';
import Model from '@/models/Model.js';
import TermScheduleTemplatePeriod from '@/models/TermScheduleTemplatePeriod.js';

export default class TermScheduleTemplatePeriodCourseTemplate extends Model {
    static entity = 'term_schedule_template_period_course_templates';

    static modelName = 'TermScheduleTemplatePeriodCourseTemplate';

    static fields() {
        return {
            id: this.attr(null),
            course_code_id: this.attr(null),
            term_schedule_template_period_id: this.attr(null),
            course_template_id: this.attr(null),
            uuid: this.attr(null),
            title: this.attr(null),
            start_week: this.attr(null),
            start_day: this.attr(null),
            duration: this.attr(null),
            credits: this.attr(null),
            hours: this.attr(null),
            order: this.attr(null),
            type: this.attr(null),

            ...super.fields(),

            course_code: this.belongsTo(CourseCodes, 'course_code_id'),
            course_template: this.belongsTo(CourseTemplate, 'course_template_id'),
            period: this.belongsTo(TermScheduleTemplatePeriod, 'term_schedule_template_period_id'),
        };
    }
}
